export enum LocalStorageKeys {
  OnboardingSurveyFormKey = "formx.onboarding.survey_form",
  DataLogFeatureRequested = "formx.data_log.feature.requested",
}
